import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || 'https://api.marketlite.app/api/v1';

const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Attach the correct token dynamically
api.interceptors.request.use(
  (config) => {
    // Check for user token first, then admin token
    const userToken = localStorage.getItem('userToken');
    const adminToken = localStorage.getItem('adminToken');

    const token = userToken || adminToken;

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle 401/403 responses globally — auto-logout on expired/invalid tokens
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const { status } = error.response;
      if (status === 401 || status === 403) {
        const isLoginRequest = error.config?.url?.includes('/login');
        if (!isLoginRequest) {
          localStorage.removeItem('userToken');
          localStorage.removeItem('adminToken');
          localStorage.removeItem('user');
          localStorage.removeItem('admin');
          window.location.href = '/home';
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;
